import React, { createContext, useContext, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import SearchService from "../../../services/SearchService";
import useToken from "../../../customHooks/useToken";
import { QUERRYIDS } from "../../../constants/queryIds";

const SearchContext = createContext();

const SearchProvider = (props) => {
  const { children } = props;
  const csrfToken = useToken();
  const userId = useSelector(({ applicationUser }) => applicationUser?.uuid);
  const [type, setType] = useState(null);
  const [query, setQuery] = useState("");

  const searchResults = useQuery(
    [QUERRYIDS.fetchSearchResults, query, type],
    () => SearchService.search(query, type, 0, 10, userId, csrfToken),
    {
      enabled: query !== "", // Only search when there's a query
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
    }
  );

  const onCategoryChange = (value) => {
    value ? setType(value) : setType(null);
  };

  const loading = query !== "" && searchResults.isLoading;

  const value = {
    type,
    query,
    loading,
    onCategoryChange,
    listItems: searchResults?.data?.items || [],
    onSearch: setQuery,
    meta: searchResults?.data?.meta,
  };

  return (
    <SearchContext.Provider value={value}>{children}</SearchContext.Provider>
  );
};

const useSearch = () => {
  const context = useContext(SearchContext);
  if (context === undefined) {
    throw new Error("useSearch must be used within a SearchProvider");
  }
  return context;
};

export { SearchProvider, useSearch };
